module.exports = __webpack_public_path__ + "media/images/home/checkin-star-white-165b90306b4a0a7ef5c84879fe6f8643.png";